import { useTicketTypesSubscriber } from '../../services/store';

const useTicketTypesResource = () => {
	const [{ data, loading, error }] = useTicketTypesSubscriber();

	return [data, loading, error] as const;
};

export default useTicketTypesResource;
